import { type SwarovskiOptikLocaleFrontend, type TranslatedValue } from "@swo/storefront";
import { formatOptionalStartingPrice } from "../../domain/swarovski-optik/products/price/format-price";
import { head } from "../../utils/fp/missing-ts-parts";
import { nonEmpty } from "../../utils/fp/small-fp-utils";
import type { Product } from "./other-products-in-family";
import { hasDiscount } from "../../domain/products";

export function mapProduct(
  selectedProductKey: string | undefined,
  fromPriceLabel: TranslatedValue,
  lowestPriceLast30DaysTranslation: TranslatedValue,
  locale: SwarovskiOptikLocaleFrontend,
) {
  return (product: Product) => {
    const isSelected = !!(selectedProductKey && product.key === selectedProductKey);

    const { path, name, key, startingPrice } = product;
    const { gallery, thumbnail } = product.images;

    const images = [
      thumbnail,
      ...gallery.flatMap(g => (g.__typename === "UtilityImageWithFocalPoint" ? [g.image] : [])),
    ].filter(nonEmpty);

    const startingPriceLabel = formatOptionalStartingPrice(
      product.startingPrice
        ? {
            startingPrice: product.startingPrice,
            discountedStartingPrice: hasDiscount(product.discountedStartingPrice)
              ? product.discountedStartingPrice
              : undefined,
            lowestPrice30Days: product.lowestPrice30Days,
            discountPercentage: product.discountPercentage,
          }
        : undefined,
      fromPriceLabel,
      lowestPriceLast30DaysTranslation,
      locale,
      true,
    );

    return {
      path,
      name,
      key,
      startingPrice,
      image: head(images),
      isSelected,
      startingPriceLabel,
      isDiscounted: hasDiscount(product.discountedStartingPrice),
    };
  };
}

export type PDPCarouselProduct = ReturnType<ReturnType<typeof mapProduct>>;
